/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import React from "react";
import { useSelector } from "react-redux";

import "./RMDComponent.scss";


import RMDFooter from "../../RMDFooter/RMDFooter";
import {
  getRMDSummary,
} from "../../../../redux/modules/RMD/RMDSetting.selectors";
import { getOnlyOWNRRMDs } from "../../../../redux/modules/UserFunds/userFunds.selectors";
import RMDAccounts from "../RMDAccounts/RMDAccounts";
import RMDSummary from "./RMDSummary/RMDSummary";

const RMDComponent = () => {
  const rmdSummary = useSelector(getRMDSummary);
  const existingRMD = useSelector(getOnlyOWNRRMDs);
  const currentRmdYear = rmdSummary.rmdYear;
  const displaySetupLink = rmdSummary.displaySetupLink;
  const showYTDColumns = rmdSummary.displayDistributionColumns;
  const amountDist = rmdSummary.distributedAmountRMD; //Amount distributed to date
  const amountDistToDate = rmdSummary.amountToBeDistributed; //Amount to be distributed
  const setUpRmd =
    existingRMD && existingRMD.length > 0;
  const pendingRMD = existingRMD?.pendingRMD;
  return (
    <div id="RMD-component">
      <RMDSummary
        isYTDColumnsShown={showYTDColumns}
        totalRMD={rmdSummary.totalRMD}
        displaySetupLink={displaySetupLink}
        rmdYear={currentRmdYear}
        amountDist={amountDist}
        amountDistToDate={amountDistToDate}
        setUpRmd={setUpRmd}
        pendingRMD={pendingRMD}
      />
      <RMDAccounts />
      <RMDFooter showYTDColumns={showYTDColumns} />
    </div>
  );
};

export default RMDComponent;
